export const semanticClassNames = {
  dropdownContainer: 'dropdown-container',
} as const;

// TODO: Change it once we finish the migration from SHM to the New menu
export default {};
